export function initializeSlider() {
    // quote Slider
    var swiper = new Swiper(".vs-slider-quote", {
       // spaceBetween: 30,
       // centeredSlides: true,
        autoHeight: false,
        loop: true,
        pagination: {
            el: ".vs-slider-quote-wrapper__pagination",
            clickable: true
        }
    });

    // Teaser Slider
    var swiper = new Swiper(".vs-slider-teaser", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-vs-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-vs-button-next",
            prevEl: ".swiper-vs-button-prev",
        },
        breakpoints: {
            900: {
                slidesPerView: 2,

            },
            1052: {
                slidesPerView: 3,
            },
            1350: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });

    // career slider
    var careerThumbnail = new Swiper('.slider-career-thumbnail', {
        slidesPerView: 6,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        loop: false,
    });

    var career = new Swiper('.slider-career-main', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 30,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: careerThumbnail
        }
    });

    var swiper = new Swiper(".vs-slider-img", {
        slidesPerView: 4.3,
        spaceBetween: 30,
        loop: true,
     });

}


